"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GasOverflowError = exports.NoSignaturesError = exports.TooManySignaturesError = exports.InsufficientFeeError = exports.MemoTooLargeError = exports.OutOfGasError = exports.InvalidGasWantedError = exports.InvalidCoinsError = exports.InsufficientCoinsError = exports.InvalidPubKeyError = exports.UnknownAddressError = exports.InvalidAddressError = exports.UnknownRequestError = exports.InsufficientFundsError = exports.UnauthorizedError = exports.InvalidSequenceError = exports.TxDecodeError = exports.InternalError = exports.TM2Error = void 0;
var messages_1 = require("./messages");
var TM2Error = /** @class */ (function (_super) {
    __extends(TM2Error, _super);
    function TM2Error(message, log) {
        var _this = _super.call(this, message) || this;
        _this.log = log;
        return _this;
    }
    return TM2Error;
}(Error));
exports.TM2Error = TM2Error;
var InternalError = /** @class */ (function (_super) {
    __extends(InternalError, _super);
    function InternalError(log) {
        return _super.call(this, messages_1.InternalErrorMessage, log) || this;
    }
    return InternalError;
}(TM2Error));
exports.InternalError = InternalError;
var TxDecodeError = /** @class */ (function (_super) {
    __extends(TxDecodeError, _super);
    function TxDecodeError(log) {
        return _super.call(this, messages_1.TxDecodeErrorMessage, log) || this;
    }
    return TxDecodeError;
}(TM2Error));
exports.TxDecodeError = TxDecodeError;
var InvalidSequenceError = /** @class */ (function (_super) {
    __extends(InvalidSequenceError, _super);
    function InvalidSequenceError(log) {
        return _super.call(this, messages_1.InvalidSequenceErrorMessage, log) || this;
    }
    return InvalidSequenceError;
}(TM2Error));
exports.InvalidSequenceError = InvalidSequenceError;
var UnauthorizedError = /** @class */ (function (_super) {
    __extends(UnauthorizedError, _super);
    function UnauthorizedError(log) {
        return _super.call(this, messages_1.UnauthorizedErrorMessage, log) || this;
    }
    return UnauthorizedError;
}(TM2Error));
exports.UnauthorizedError = UnauthorizedError;
var InsufficientFundsError = /** @class */ (function (_super) {
    __extends(InsufficientFundsError, _super);
    function InsufficientFundsError(log) {
        return _super.call(this, messages_1.InsufficientFundsErrorMessage, log) || this;
    }
    return InsufficientFundsError;
}(TM2Error));
exports.InsufficientFundsError = InsufficientFundsError;
var UnknownRequestError = /** @class */ (function (_super) {
    __extends(UnknownRequestError, _super);
    function UnknownRequestError(log) {
        return _super.call(this, messages_1.UnknownRequestErrorMessage, log) || this;
    }
    return UnknownRequestError;
}(TM2Error));
exports.UnknownRequestError = UnknownRequestError;
var InvalidAddressError = /** @class */ (function (_super) {
    __extends(InvalidAddressError, _super);
    function InvalidAddressError(log) {
        return _super.call(this, messages_1.InvalidAddressErrorMessage, log) || this;
    }
    return InvalidAddressError;
}(TM2Error));
exports.InvalidAddressError = InvalidAddressError;
var UnknownAddressError = /** @class */ (function (_super) {
    __extends(UnknownAddressError, _super);
    function UnknownAddressError(log) {
        return _super.call(this, messages_1.UnknownAddressErrorMessage, log) || this;
    }
    return UnknownAddressError;
}(TM2Error));
exports.UnknownAddressError = UnknownAddressError;
var InvalidPubKeyError = /** @class */ (function (_super) {
    __extends(InvalidPubKeyError, _super);
    function InvalidPubKeyError(log) {
        return _super.call(this, messages_1.InvalidPubKeyErrorMessage, log) || this;
    }
    return InvalidPubKeyError;
}(TM2Error));
exports.InvalidPubKeyError = InvalidPubKeyError;
var InsufficientCoinsError = /** @class */ (function (_super) {
    __extends(InsufficientCoinsError, _super);
    function InsufficientCoinsError(log) {
        return _super.call(this, messages_1.InsufficientCoinsErrorMessage, log) || this;
    }
    return InsufficientCoinsError;
}(TM2Error));
exports.InsufficientCoinsError = InsufficientCoinsError;
var InvalidCoinsError = /** @class */ (function (_super) {
    __extends(InvalidCoinsError, _super);
    function InvalidCoinsError(log) {
        return _super.call(this, messages_1.InvalidCoinsErrorMessage, log) || this;
    }
    return InvalidCoinsError;
}(TM2Error));
exports.InvalidCoinsError = InvalidCoinsError;
var InvalidGasWantedError = /** @class */ (function (_super) {
    __extends(InvalidGasWantedError, _super);
    function InvalidGasWantedError(log) {
        return _super.call(this, messages_1.InvalidGasWantedErrorMessage, log) || this;
    }
    return InvalidGasWantedError;
}(TM2Error));
exports.InvalidGasWantedError = InvalidGasWantedError;
var OutOfGasError = /** @class */ (function (_super) {
    __extends(OutOfGasError, _super);
    function OutOfGasError(log) {
        return _super.call(this, messages_1.OutOfGasErrorMessage, log) || this;
    }
    return OutOfGasError;
}(TM2Error));
exports.OutOfGasError = OutOfGasError;
var MemoTooLargeError = /** @class */ (function (_super) {
    __extends(MemoTooLargeError, _super);
    function MemoTooLargeError(log) {
        return _super.call(this, messages_1.MemoTooLargeErrorMessage, log) || this;
    }
    return MemoTooLargeError;
}(TM2Error));
exports.MemoTooLargeError = MemoTooLargeError;
var InsufficientFeeError = /** @class */ (function (_super) {
    __extends(InsufficientFeeError, _super);
    function InsufficientFeeError(log) {
        return _super.call(this, messages_1.InsufficientFeeErrorMessage, log) || this;
    }
    return InsufficientFeeError;
}(TM2Error));
exports.InsufficientFeeError = InsufficientFeeError;
var TooManySignaturesError = /** @class */ (function (_super) {
    __extends(TooManySignaturesError, _super);
    function TooManySignaturesError(log) {
        return _super.call(this, messages_1.TooManySignaturesErrorMessage, log) || this;
    }
    return TooManySignaturesError;
}(TM2Error));
exports.TooManySignaturesError = TooManySignaturesError;
var NoSignaturesError = /** @class */ (function (_super) {
    __extends(NoSignaturesError, _super);
    function NoSignaturesError(log) {
        return _super.call(this, messages_1.NoSignaturesErrorMessage, log) || this;
    }
    return NoSignaturesError;
}(TM2Error));
exports.NoSignaturesError = NoSignaturesError;
var GasOverflowError = /** @class */ (function (_super) {
    __extends(GasOverflowError, _super);
    function GasOverflowError(log) {
        return _super.call(this, messages_1.GasOverflowErrorMessage, log) || this;
    }
    return GasOverflowError;
}(TM2Error));
exports.GasOverflowError = GasOverflowError;
